<template>
    <div>
        <contact-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addContact">
                    <i class="far fa-file"></i>
                </button>
            </template>
        </contact-table>
        <dialog-form-wrapper></dialog-form-wrapper>
    </div>
</template>

<script>
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';
  import ContactTable from '../../components/contact/table';

  export default {
    components: {
      DialogFormWrapper,
      ContactTable,
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },

      /**
       * @event show-add-contact-dialog
       */
      addContact() {
        eventBus.$emit('show-add-contact-dialog', this.createUrl);
      },


    },

    created() {
      eventBus.$on('refresh-contacts-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-contacts-table', this.refresh);
    }
  }
</script>

